import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { TranslateModule, TranslateLoader, LangChangeEvent } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const translationOptions = {
  loader: {
    provide: TranslateLoader,
    useFactory: (createTranslateLoader),
    deps: [HttpClient]
  }
};

var language;

@NgModule({
  imports: [TranslateModule.forRoot(translationOptions)],
  exports: [TranslateModule],
  providers: [TranslateService]
})
export class AppTranslationModule {
  constructor(public translate: TranslateService) {
    translate.addLangs(["en", "es"]);
    translate.setDefaultLang('pt');
    
    
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // console.log(event);
      this.translate.use(event.lang);
      translate.use(event.lang);
      translate.setDefaultLang(event.lang);
      language = event.lang;
    });
    if(language !== null){
      translate.use(language);
    }
  }
  setLanguage():string{
    this.translate.use(language);
    return language;
  }

  getLanguage(){
    return language;
  }
}
